
import { useStore } from "../../state/state.ts";
import Measure from "../measure.tsx";
import ModalFenster from "../../modals/modal_fenster.tsx";
import ModalFensterFuture from "../../modals/modal_fenster_future.tsx";
import { MASSNAHMEN_FENSTER_OPTIONS_CURRENT_LABELS, MASSNAHMEN_FENSTER_OPTIONS_NEW_LABELS } from "../../state/types.ts";

export default function MeasureWidgetFenster() {
  // @ts-ignore:TS6133
  const fenster = useStore((state)=>state.fenster || "");
  const fenster_future = useStore((state)=>state.fenster_future || "");

  const push_modal = useStore((state) => state.push_modal_closeable);
  const is_step_id = useStore((state) => state.is_step_id);
  const measure_lables = useStore((state)=>state.measure_lables);

  if (fenster == "" && fenster_future == ""){
    return <></>;
  }

  const current = measure_lables[fenster] || MASSNAHMEN_FENSTER_OPTIONS_CURRENT_LABELS[fenster] || "" ;
  const future = measure_lables[fenster_future] || MASSNAHMEN_FENSTER_OPTIONS_NEW_LABELS[fenster_future] || "" ;
  
  return <Measure key={"measure-widget-fenster"} label={"Fenster"} now={current} future={future} onClick={() => push_modal(is_step_id("future")?<ModalFensterFuture/>:<ModalFenster/>)}/>;
}
